import React from 'react';

import ImgPreviewerModalContainer from './ImgPreviewerModalContainer';

interface IShipNowPaymentModal {
  imgUrl: string;
}

const PreviewImageModal: React.FC<IShipNowPaymentModal> = ({ imgUrl }) => {
  return (
    <ImgPreviewerModalContainer imgUrl={imgUrl}></ImgPreviewerModalContainer>
  );
};

export default PreviewImageModal;
